export default __webpack_public_path__ + "static/media/mudslide.46656736.svg";